// extracted by mini-css-extract-plugin
export default {"instant-settlement":"instant-settlement_instant-settlement__LD9Jx","instant-settlement__body":"instant-settlement_instant-settlement__body__v8RM6"};